module.exports = __webpack_public_path__ + "img/emoji_25.743b915e.png";